import React from 'react'
import MobileLayout from '../components/layout/MobileLayout'

const UserMain: React.FC = () => {
  return (
    <MobileLayout>
      <div>User Main Page</div>
    </MobileLayout>
  )
}

export default UserMain
